// Meant to be used as a component for redux-form's Field.

import React from 'react';

function constructProps(originalProps) {
  const { input, onChangeCustom } = originalProps;

  const _props = Object.assign({}, originalProps);
  delete _props.input;
  delete _props.meta;
  delete _props.onChangeCustom;

  const _input = Object.assign({}, input);
  delete _input.checked;
  _input.onChange = e => {
    input.onChange(e);
    if (onChangeCustom != null) {
      onChangeCustom(e);
    }
  };

  let defaultChecked = originalProps.defaultChecked;
  if (defaultChecked == null) {
    defaultChecked = input.checked;
  }

  return {..._props, ..._input, defaultChecked};
}

export class CustomBooleanInput extends React.Component {
  render() {
    const props = constructProps(this.props);

    return (
      <input {...props} />
    );
  }
}

export class CustomSelect extends React.Component {
  render() {
    const props = constructProps(this.props);

    return (
      <select {...props}>
        {this.props.children}
      </select>
    );
  }
}
